import React from "react";
import Faq from "react-faq-component";



const data = {
  title: "Frequently Asked Questions (FAQs)",
  rows: [
    {
      title: "Who are we?",
      content: `We are a private firm who invests, trades, builds, rebuilds, make and grows real estate projects.`,
    },
    {
      title: "Why the old fashioned way of joining with us?",
      content:
        "While we are working on a better way to serve you, we dont want you to miss out on investing opportunities. We also want you to connect with us personally and understand your needs to serve you better.",
    },
    {
      title: "Is there a minimum investment amount?",
      content: `You can start with as low as INR 1000 (Indian Rupees One Thousand) when investing in any project.`,
    },
    {
      title: "Is there a joining fee?",
      content: `You will be charged a one-time onboarding fee of INR 399/-. This fee will be waived off if your first investment with us is over INR15,000/-`,
    },
    {
      title: "Why is there a joining fee?",
      content: `We offer services on a personlized level to ensure you always know what we're upto and together we can build up trust and grow together. In order to manage all of it properly, we require to maintain this criteria for a nominal INR 399/- onboarding fee so as to ensure smooth funcitoning.`,
    },
    {
      title: "How to join/register with us?",
      content: `You can go to our <a href="/">homepage</a> and then Get started by filling the contact form. We will reach out to you at a convenient time and get you onboarded post KYC verification.`,
    },
    {
      title: "Is there an eligibility criteria to join?",
      content: `Provided you have all your identity proof, address proof, bank details and nominee details ready with you, we don't have any such criteria.`,
    },
    {
      title: "Why is address required?",
      content: `In any unfortunate incident we dont want you to lose your investment. We willr each out to your nominee and provide all the invested amount + returns to your nominee.`,
    },
    {
      title: "What details of the nominee are required?",
      content: `Nominee name, address, contact (email and mobile), relation and identity proof document.`,
    },
    {
      title: "Is there a maximum limit to investment?",
      content: `Currently we would want you to work things out with us hence we recommend that you invest any small amount with us and experience what we have to offer. We have not capped any maximum investment amount. However, if you wish to invest an amount that equals to or is greator than 10% of the project value, we want you to connect with you to understand your position and get you a better deal.`,
    },
    {
      title: "Is there any risk?",
      content: `Real estate investments are much better than any other. Since Food, shelter and clothing are the basic needs of humans, the demand will always be high for real estate hence it will always be on the upper side. There are however chances that the value of a property declines or remains stagnant for a long time. However, given our long experience in this field we know what we are doing; hence we are so sure that it'll turn out to be the best`,
    },
    {
      title: "Do you only invest in high valuation properties?",
      content: `We are opportunists and we research a lot. High value properties are not always available for a project and we have a team that can support multiple projects in parallel hence we deal in low to high valued projects with the same enthusiasm.`,
    },
    {
      title: "How do we earn?",
      content: `We ourselves are the investors always and we also take a small cut from the profits once the project is completed.`,
    },
    {
      title: "What is Rental Returns?",
      content: `In rental returns you can invest a lum-sump amount with us to receive the interest on that amount on a monthly basis (like rent). Example: If you invest INR 10,000/- with us with the Rental returns option, we give you returns starting 9% (per anum) (based on certain criteria we may offer a higher interest rate). Assuming the interest rate is 10% per anum for the invested amount INR 10,000/-, you are set to receive 1000/12 = ~INR 84 per month till the project is completed and the entire invested amount after the project is completed.`,
    },
    {
      title: "Is there a lock in period?",
      content: `There is a lock in period which is equal to the project tenure (don't worry, our projects complete before the given tenure; we like to keep some buffer time to handle covid-like scenarios)`,
    },
    {
      title:
        "Is there a penalty if I want to withdraw funds before the project completes?",
      content: `In the rental return plan, we will support you if you urgently need your funds on a minimum of 1 month notice period i.e. you are to inform us atleast a month in advance and we will get you your funds back.`,
    },
    {
      title: "How do I ensure this is trustworthy?",
      content: `We are a private company and we are a decently sized firm. Our team contains of people who we have worked with in the past and whom we trust.`,
    },
    {
      title: "How can I understand what happens to my money once it's invested?",
      content: `Our leads would setup sessions with you after you are onboarded and give you a brief on what the business is and help you grow your money with a plan. Our leads want to connect with you directly to offer you a great experience and make you feel comfortable.`,
    },
    // {
    //   title: "",
    //   content: ``,
    // },
    // {
    //   title: "",
    //   content: ``,
    // },
    {
      title: "Still need more support?",
      content: `Send an email to us`,
    },
  ],
};

const styles = {
  bgColor: "#151719",
  titleTextColor: "White",
  rowTitleColor: "White",
  rowContentColor: "grey",
  arrowColor: "#5e17eb",
  rowContentPaddingTop: "15px",
  rowContentPaddingBottom: "50px",
  rowContentPaddingLeft: "50px",
  rowContentPaddingRight: "50px",
};

const config = {
  animate: true,
  tabFocus: true,
};

const FAQs = () => {
  return (
      <div className="faq-content container">
        <Faq
          className="faq-panel"
          data={data}
          styles={styles}
          config={config}
        />

      </div>
  );
};

export default FAQs;
